import { Header } from "./types";

export const authHeader: Header = {
  key: "Ocp-Apim-Subscription-Key",
  value: import.meta.env.VITE_APP_API_KEY || "",
};
